import { Palette } from '../constants/palette';
export const alertVariants = {
    variants: {
        success: {
            color: Palette.green,
            borderColor: Palette.green,
            borderRadius: 'xxs',
        },
        error: {
            color: Palette.red,
            borderColor: Palette.red,
            borderRadius: 'xxs',
        },
        info: {
            color: Palette.blue,
            borderColor: Palette.blue,
            borderRadius: 'xxs',
        },
        warning: {
            color: Palette.orange,
            borderColor: Palette.orange,
            borderRadius: 'xxs',
        },
        pending: {
            color: Palette.orange,
            borderColor: Palette.orange,
            borderRadius: 'xxs',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxlcnQtdmFyaWFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvYWxlcnQtdmFyaWFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBRy9DLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBMkI7SUFDbkQsUUFBUSxFQUFFO1FBQ1IsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFLE9BQU8sQ0FBQyxLQUFLO1lBQ3BCLFdBQVcsRUFBRSxPQUFPLENBQUMsS0FBSztZQUMxQixZQUFZLEVBQUUsS0FBSztTQUNwQjtRQUNELEtBQUssRUFBRTtZQUNMLEtBQUssRUFBRSxPQUFPLENBQUMsR0FBRztZQUNsQixXQUFXLEVBQUUsT0FBTyxDQUFDLEdBQUc7WUFDeEIsWUFBWSxFQUFFLEtBQUs7U0FDcEI7UUFDRCxJQUFJLEVBQUU7WUFDSixLQUFLLEVBQUUsT0FBTyxDQUFDLElBQUk7WUFDbkIsV0FBVyxFQUFFLE9BQU8sQ0FBQyxJQUFJO1lBQ3pCLFlBQVksRUFBRSxLQUFLO1NBQ3BCO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFLE9BQU8sQ0FBQyxNQUFNO1lBQ3JCLFdBQVcsRUFBRSxPQUFPLENBQUMsTUFBTTtZQUMzQixZQUFZLEVBQUUsS0FBSztTQUNwQjtRQUNELE9BQU8sRUFBRTtZQUNQLEtBQUssRUFBRSxPQUFPLENBQUMsTUFBTTtZQUNyQixXQUFXLEVBQUUsT0FBTyxDQUFDLE1BQU07WUFDM0IsWUFBWSxFQUFFLEtBQUs7U0FDcEI7S0FDRjtDQUNGLENBQUMifQ==